// @flow

import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { log } from '../../utils/jsUtils';
import MemberDrawer from '../MemberDrawer/index';
import StaffListHeader from './StaffListHeader';
import StaffListContent from './StaffListContent';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { createClasses } from '../../utils/stylesUtils';
import sharedLayoutStyles from '../Styles/SharedLayoutStyles.Style';

type Props = {
  classes?: Object
};

const PropertyHome = (props: Props) => {
  const theme = useTheme();
  const classes = createClasses(sharedLayoutStyles, theme);

  // drawer state & controls
  const [mobileOpen, setMobileOpen] = useState(false);

  const usehandleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={classes.homeRoot}>
      <Helmet>
        <title>Neo | Staff</title>
      </Helmet>
      <StaffListHeader
        mobileOpen={mobileOpen}
        usehandleDrawerToggle={usehandleDrawerToggle}
      />
      <MemberDrawer
        mobileOpen={mobileOpen}
        usehandleDrawerToggle={usehandleDrawerToggle}
      />
      <StaffListContent />
    </Box>
  );
};

export default PropertyHome;
